module.exports = __webpack_public_path__ + "img/account-icon.de6cb22b.svg";